import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { calculateNewUrlWithCriteria } from '@/components/Search/utils';

const useReplaceWindowURL = () => {
  const { replace } = useRouter();
  const replaceWindowUrl = useCallback(
    async (
      queryParams: Record<string, string | string[] | boolean | number>
    ): Promise<void> => {
      await replace(
        calculateNewUrlWithCriteria({
          url: new URL(window.location.href),
          queryParams,
        }),
        undefined,
        {
          scroll: false,
          shallow: true,
        }
      );
    },
    [replace]
  );

  return {
    replaceWindowUrl,
  };
};

export default useReplaceWindowURL;
